import PropTypes from 'prop-types'
import { Observer } from 'mobx-react-lite'
import { Divider } from 'ui-components-web'

import { Row, SectionHeader } from '../../common'

const Section = ({ title, rows, visit, onEdit }) => {
  return (
    <>
      <Observer>
        {() => (
          <SectionHeader
            onEdit={onEdit}
            title={title}
            hasIncomplete={rows.some((row) => {
              const isRequired = typeof row.required === 'function' ? row.required(visit) : row.required
              return isRequired && row.getIsEmpty(visit)
            })}
          />
        )}
      </Observer>

      {rows.map(({ label, required, incompleteMessage, getContent, getIsEmpty, showCompleteIcon }) => (
        <Observer key={label}>
          {() => {
            const isEmpty = getIsEmpty(visit)
            const isRequired = typeof required === 'function' ? required(visit) : required
            if (!isRequired && isEmpty) {
              return null
            }
            const content = getContent(visit)
            if (!isRequired && !content) {
              return null
            }
            return (
              <Row
                label={label}
                required={isRequired}
                incompleteMessage={incompleteMessage}
                content={isEmpty ? '' : content}
                showCompleteIcon={showCompleteIcon}
              />
            )
          }}
        </Observer>
      ))}

      {title !== 'discharge' && <Divider />}
    </>
  )
}
Section.propTypes = {
  title: PropTypes.string.isRequired,
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      required: PropTypes.bool.isRequired,
      incompleteMessage: PropTypes.string.isRequired,
      getContent: PropTypes.func.isRequired,
      getIsEmpty: PropTypes.func.isRequired,
    }),
  ).isRequired,
  visit: PropTypes.object,
  onEdit: PropTypes.func,
}

export default Section
